import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { take, pipe } from 'rxjs';
import { ReportService } from '@core/services/report.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '@core/services/auth.service';
import { SelectType } from '@core/enums/select';
import { IReportAction, IReportType } from '@core/interfaces/ireport-type';
import { IAgeGradeInstrument } from '@core/interfaces/iage-grade-instrument';
import { ISchoolYear } from '@core/interfaces/iratingperiod';

@Component({
    selector: 'drdp-report-tracking',
    templateUrl: './report-tracking.component.html',
    styleUrls: ['./report-tracking.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class ReportTrackingComponent implements OnInit {
  user = this.authService.getCurrentUser();
  ratingCompletionSearch: FormGroup | any;
  clearDropdowns: boolean = false;
  allAgencies: boolean = false;
  btnClass: string = 'lg:col-span-3';

  get reportTypeIds() { return this.ratingCompletionSearch.get('reportTypeIds'); }
  get stateId() { return this.ratingCompletionSearch.get('stateId'); }
  get schoolYearId() { return this.ratingCompletionSearch.get('schoolYearId'); }
  get agencyId() { return this.ratingCompletionSearch.get('agencyId'); }
  get globalRatingPeriodIds() { return this.ratingCompletionSearch.get('globalRatingPeriodIds'); }
  get ageGradeInstrumentIds() { return this.ratingCompletionSearch.get('ageGradeInstrumentIds'); }
  get reportActionIds() { return this.ratingCompletionSearch.get('reportActionIds'); }
  public get selectType() { return SelectType; }

  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private reportService: ReportService) { }

  ngOnInit(): void {
    this.initializeForm();
  }

  handleDownload(): void {
    let payload = this.ratingCompletionSearch.value;
    this.reportService.getReportUsage(payload).pipe(take(1)).subscribe((res: any) => {
        const file = new Blob([res], { type: 'text/csv' });
        const fileUrl = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = fileUrl;
        let fileName = 'ReportUsage';
        link.download = `${fileName.replace(/ /g, '_')}.csv`;
        link.click();
    });
  }

  initializeForm(): void {
    this.ratingCompletionSearch = this.fb.group({
      reportTypeIds: [null, Validators.required],
      stateId: [this.authService.getUserStateId(), Validators.required],
      agencyId: [this.authService.getCurrentUser().agencyId ?? null],
      globalRatingPeriodIds: [null],
      schoolYearId: [null],
      ageGradeInstrumentIds: [null],
      reportActionIds: [null]
    });
  }

  handleDropdown(event: any, type: string): void {
    switch (type) {
      case SelectType.ReportType:
        let reportTypeIds = event?.map((reportType: IReportType) => reportType.id)
        this.reportTypeIds.setValue(reportTypeIds.toString());
        break;
      case SelectType.States:
        this.stateId.setValue(event?.id);
        this.agencyId.setValue(null);
        this.globalRatingPeriodIds.setValue(null);
        break;
      case SelectType.Agencies:
        this.agencyId.setValue(event?.id);
        break;
      case SelectType.RatingPeriods:
        let ratingPeriodIds = event?.map((ratingPeriod: any) => this.allAgencies ? ratingPeriod.id : ratingPeriod.globalRatingPeriodId);
        this.globalRatingPeriodIds.setValue(ratingPeriodIds.toString());
        break;
    case SelectType.SchoolYear:
        this.schoolYearId.setValue(event?.id);
        break;
    case SelectType.AgeInstrument:
        let ageGradeInstrumentIds = event?.map((ageInstrument: IAgeGradeInstrument) => ageInstrument.id);
        this.ageGradeInstrumentIds.setValue(ageGradeInstrumentIds.toString());
        break;
    case SelectType.ReportAction:
        let reportActionIds = event?.map((reportAction: IReportAction) => reportAction.id);
        this.reportActionIds.setValue(reportActionIds.toString());
        break;
    }
  }

  handleGlobal(): void {
    this.allAgencies = !this.allAgencies;
    this.btnClass = this.allAgencies ? 'lg:col-span-4' :'lg:col-span-3';
    this.agencyId.setValue(null);
  }

}
